import React from 'react';
import { DIAMOND_AMC, IMAGES } from '../mock';
import { Check, Gift, Sparkles, ChevronRight, ShieldCheck, Clock } from 'lucide-react';
import { Button } from './ui/button';

export default function AMCSection({ onBook }) {
  return (
    <section id="amc" className="relative py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <div className="section-title-eyebrow uppercase">Best Value Plan</div>
          <h2 className="mt-3 text-3xl md:text-5xl font-extrabold">
            <span className="gradient-text">DIAMOND AMC PLAN</span>
          </h2>
          <p className="mt-4 text-gray-400">મોટી બચત — 48 સર્વિસ ફક્ત ₹5,000 માં! <span className="text-pink-400">Only ₹111/service</span></p>
        </div>

        {/* SINGLE UNIFIED CARD */}
        <div className="rounded-3xl p-[1.5px]" style={{background:'linear-gradient(135deg,#a855f7,#ec4899)'}}>
          <div className="rounded-3xl bg-[#0f0f16] overflow-hidden">
            {/* Top: image banner */}
            <div className="relative h-40 md:h-48">
              <img src={IMAGES.amc} alt="AMC service" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-r from-[#0f0f16] via-[#0f0f16]/60 to-transparent md:bg-gradient-to-r" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f0f16] via-transparent to-transparent" />
              <div className="absolute left-5 top-4">
                <div className="tag-pill"><Sparkles className="w-3 h-3" /> {DIAMOND_AMC.tag}</div>
              </div>
              <div className="absolute left-5 bottom-4">
                <h3 className="text-white text-xl md:text-2xl font-extrabold">{DIAMOND_AMC.name}</h3>
                <div className="text-[11px] tracking-widest text-gray-300 mt-0.5">2 વર્ષ · 48 સર્વિસ · ₹111/સર્વિસ</div>
              </div>
            </div>

            <div className="p-6 md:p-8">
              {/* Pricing row */}
              <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 border-b border-purple-900/40 pb-6">
                <div>
                  <div className="flex items-baseline gap-3">
                    <div className="text-4xl md:text-5xl font-extrabold gradient-text">₹4,999</div>
                    <div className="text-sm text-gray-400">+ GST</div>
                  </div>
                  <div className="mt-1 flex items-center gap-2 text-sm">
                    <span className="text-red-400 line-through decoration-red-500 decoration-2">₹24,400</span>
                    <span className="text-green-400 font-semibold">80% બચત</span>
                  </div>
                </div>
                <div className="grid grid-cols-3 gap-2 sm:gap-3 max-w-sm">
                  <div className="rounded-xl border border-purple-900/60 py-2.5 px-2 text-center">
                    <Clock className="w-4 h-4 mx-auto text-pink-400" />
                    <div className="mt-1 text-white text-xs font-semibold">2 વર્ષ</div>
                  </div>
                  <div className="rounded-xl border border-purple-900/60 py-2.5 px-2 text-center">
                    <ShieldCheck className="w-4 h-4 mx-auto text-pink-400" />
                    <div className="mt-1 text-white text-xs font-semibold">48 સર્વિસ</div>
                  </div>
                  <div className="rounded-xl border border-purple-900/60 py-2.5 px-2 text-center">
                    <Sparkles className="w-4 h-4 mx-auto text-pink-400" />
                    <div className="mt-1 text-white text-xs font-semibold">₹111/સર્વિસ</div>
                  </div>
                </div>
              </div>

              {/* Complimentary + Services in same card */}
              <div className="grid lg:grid-cols-5 gap-6 pt-6">
                <div className="lg:col-span-2">
                  <div className="flex items-center gap-2 mb-3">
                    <Gift className="w-4 h-4 text-pink-400" />
                    <h4 className="text-white font-bold text-sm tracking-wide">કોમ્પ્લિમેન્ટરી (મફત)</h4>
                  </div>
                  <div className="space-y-2.5">
                    {DIAMOND_AMC.complimentary.map((c, i) => (
                      <div key={i} className="rounded-lg border border-purple-900/50 bg-[#14141c] p-3 hover-lift">
                        <div className="flex items-start gap-2">
                          <div className="text-pink-400 text-[10px] font-bold tracking-widest bg-pink-500/10 border border-pink-500/30 rounded-md px-1.5 py-0.5">FREE</div>
                          <div className="text-white text-sm font-semibold">{c.title}</div>
                        </div>
                        <div className="text-xs text-gray-400 mt-1 pl-1">{c.desc}</div>
                      </div>
                    ))}
                  </div>

                  <div className="mt-5 space-y-2">
                    <div className="text-xs uppercase tracking-widest text-gray-400 font-semibold">મુખ્ય ફાયદા</div>
                    {DIAMOND_AMC.benefits.slice(0, 5).map((b, i) => (
                      <div key={i} className="flex items-start gap-2 text-xs text-gray-300">
                        <Check className="w-3.5 h-3.5 text-pink-400 mt-0.5 shrink-0" />
                        <span>{b}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="lg:col-span-3">
                  <div className="flex items-center gap-2 mb-3">
                    <ShieldCheck className="w-4 h-4 text-pink-400" />
                    <h4 className="text-white font-bold text-sm tracking-wide">2 વર્ષમાં કુલ 48 સર્વિસ</h4>
                  </div>
                  <div className="grid sm:grid-cols-2 gap-x-5 gap-y-1.5">
                    {DIAMOND_AMC.services.map((s, i) => (
                      <div key={i} className="flex items-center justify-between gap-3 py-1.5 border-b border-purple-900/25 last:border-0">
                        <div className="flex items-center gap-2 text-sm text-gray-200 min-w-0">
                          <Check className="w-3.5 h-3.5 text-pink-400 shrink-0" />
                          <span className="truncate">{s.name}</span>
                        </div>
                        <span className="text-[11px] px-2 py-0.5 rounded-full border border-purple-800/60 text-gray-300 whitespace-nowrap shrink-0">{s.times}×</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="mt-7 pt-6 border-t border-purple-900/40 flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="text-sm text-gray-300 text-center sm:text-left">
                  <span className="text-white font-semibold">Save Big</span> — Get 48 Services for Just ₹5,000!
                </div>
                <Button onClick={() => onBook('diamond')} className="gradient-btn rounded-full h-12 px-7 font-semibold w-full sm:w-auto">
                  Diamond AMC હમણાં જ બુક કરો <ChevronRight className="w-4 h-4 ml-1" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
